import React, { useRef } from 'react';
var VeltAutocompleteChipTooltipIcon = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-autocomplete-chip-tooltip-icon", { ref: ref }, children));
};
export default VeltAutocompleteChipTooltipIcon;
